const locale = {
  placeholder: 'Select time',
};

export default locale;



// WEBPACK FOOTER //
// ./src/components/time-picker/locale/en_US.tsx